import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalId } from '../enums/local.enum';
import { Result } from '../models/result';

type PrinterLocation = 'SLA' | 'LCB';

@Injectable({ providedIn: 'root' })
export class ImpressoraService {
  private readonly apiUrl = environment.urlControlCenterApi + 'api/print';

  constructor(private http: HttpClient) {}

  printTicket(senha: string, localId: number) {
    const local = this.getPrinterLocation(localId);

    if (!local) {
      return throwError(
        () => new Error(`Impressora não configurada para o local ${localId}.`),
      );
    }

    return this.http.post<Result<boolean>>(this.apiUrl, { senha, local });
  }

  private getPrinterLocation(localId: number): PrinterLocation | null {
    if (localId === LocalId.SLA) return 'SLA';
    if (localId === LocalId.LCB) return 'LCB';
    return null;
  }
}
